<div class="errorpage-main">
	<div class="container">
		<div class="row">
			<div class="errorpage-main-box col-12 d-flex flex-wrap align-content-center">
				<h1 class="errorpage-main-header col-12 mb-3">Hovsa!</h1>
				<p class="errorpage-main-description col-12 col-md-6 offset-0 offset-md-3">Siden du søgte efter blev
					desværre ikke fundet.
					Dette kan skyldes, at siden ikke længere eksisterer, eller at siden er blevet flyttet.</p>
				<div class="col-12">
					<a href="/" class="btn btn-green btn-hero d-block d-sm-inline-block mr-0 me-sm-3">Til forsiden</a>
					<a href="/lodder-til-salg" class="btn btn-gold btn-hero d-block d-sm-inline-block me-0 me-sm-3">Køb
						lodder</a>
				</div>
			</div>
		</div>
	</div>
</div>
